export default "__VITE_ASSET__CEzACwK8__"